import classNames from 'classnames';
import React from 'react';

import { Designer } from '@graphql/Designer/queries/availableDesigners.graphql';
import { Designer as PreferredDesigner } from '@graphql/Room/queries/get-room.graphql';
import {
  IDesignerProfile
} from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';
import designerGroups from '@constants/designerGroups';
import styles from './DesignerGroupBadge.module.scss';

interface IDesignerBadge {
  designer: Designer|IDesignerProfile|PreferredDesigner;
  forGroup: number;
  classname?: string;
}

const DesignerGroupBadge = ({ designer, forGroup, classname }: IDesignerBadge) => {
  let badgeText;

  if (forGroup === designerGroups.inPerson && designer.isInPerson) {
    badgeText = 'In-Person';
  } else {
    return null;
  }

  return (
    <div className={classname}>
      <span className={classNames(styles.Badge, styles.InPersonBadge)}>{ badgeText }</span>
    </div>
  );
};

export default DesignerGroupBadge;
